
import { Environment } from './Environment';

import { IInstance } from '../interfaces/IInstance';
import DateTimeService from './DateTimeService';
import { FetchProxy } from 'intraactive-sdk-helper';
import { sdkContainerInstance } from '../global/Container';
import { Helper } from '../Helper';

export default class InstanceService {

  public static getInstances(environment: "Development" | "Test" | "Production", token: string, tenant: string, component: string, isAdmin: boolean): Promise<any[]> {
    return new Promise((resolve) => {
      tenant = tenant.replace(".sharepoint.com", "");
      const instances = localStorage.getItem(`IA_getInstances_${component}`);
      if (!isAdmin && instances && new DateTimeService().getDatePlusOneHour(new Date(JSON.parse(instances).date)) > new Date()) {
        console.log("Using cached instances");
        resolve(JSON.parse(instances).value);
      } else {
        console.log("Fetching instances from server", sdkContainerInstance);
        const url = `${Environment.getEnvironmentForMainAPI(environment)}/api/instances/getInstances/${tenant}.sharepoint.com/${component}`;
        console.log("Fetching instances from server 2", url);
        return new FetchProxy(url, {
          credentials: "same-origin",
          mode: "cors",
          headers: {
            "AuthToken": token
          }
        })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            Helper.setLocalStorage(`IA_getInstances_${component}`, JSON.stringify({
              date: new Date(),
              value: response
            }));
            resolve(response);
          }).catch((error) => {
            console.log(error);
          });
      }
    });
  }

  public static updateInstance(environment: "Development" | "Test" | "Production", token: string, tenant: string, component: string, instance: IInstance): Promise<string> {
    return new Promise<string>((resolve: (instanceName: string) => void, reject: (error: any) => void): void => {
      const url = `${Environment.getEnvironmentForMainAPI(environment)}/api/instances/updateinstance?tenantRef=${tenant}.sharepoint.com&site=${component}`;
      const body: string = JSON.stringify(
        {
          title: instance.title,
          instanceName: instance.instanceName,
          id: instance?.id,
          translationEnabled: instance.translationEnabled,
          pushEnabled: instance.pushEnabled,
          settings: instance.settings
        }
      );
      new FetchProxy(url, { method: "PUT", credentials: "same-origin", headers: { 'AuthToken': token, 'Content-Type': 'application/json' }, body: body })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            reject(response.statusText);
            return;
          }
          return resolve(response.statusText);
        })
        .catch(error => {
          console.log(error);
          resolve(null);
        });
    });
  }

  public static getInstanceIdByName(environment: "Development" | "Test" | "Production", token: string, tenant: string, component: string, instanceName: string, targeting: boolean): Promise<IInstance> {
    return new Promise<IInstance>((resolve: (instance: IInstance) => void, reject: (error: any) => void): void => {
      const tenantName = tenant.replace(".sharepoint.com", "");
      const url = `${Environment.getEnvironmentForMainAPI(environment)}/api/instances/getInstance/${tenantName}.sharepoint.com/${component}/?instanceName=${instanceName}&targeting=${targeting}`;
      new FetchProxy(url, { method: "GET", credentials: "same-origin", headers: { 'AuthToken': token, 'Content-Type': 'application/json' } })
        .withContainer(sdkContainerInstance)
        .fetch()
        .then((response) => {
          if (!response.ok) {
            throw (response.status);
          } else {
            return response.json();
          }
        }).then(response => {
          resolve(response);
        }).catch(error => {
          console.log(error);
          reject(null);
        });
    });
  }
}
